/**
 * Google Maps Constants
 * Central configuration for all map-related operations
 */

// API Configuration
export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_BASE_URL = 'https://maps.googleapis.com/maps/api';

// Default Map Settings
export const DEFAULT_MAP_CENTER = { lat: 17.385, lng: 78.4867 }; // Hyderabad
export const DEFAULT_MAP_ZOOM = 12;
export const DEFAULT_MARKER_ZOOM = 15;

// Map Styles
export const MAP_STYLES = {
  default: [],
  silver: [
    {
      elementType: 'geometry',
      stylers: [{ color: '#f5f5f5' }],
    },
    {
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [{ color: '#616161' }],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#f5f5f5' }],
    },
  ],
};

// Route Configuration
export const ROUTE_CONFIG = {
  travelMode: 'DRIVING', // DRIVING, WALKING, BICYCLING, TRANSIT
  avoidTolls: false,
  avoidHighways: false,
  avoidFerries: false,
  optimizeWaypoints: true,
};

// Marker Icons
export const MARKER_ICONS = {
  rider: '🛵',
  parcel: '📦',
  pickup: '📍',
  delivery: '🏁',
  warehouse: '🏪',
};

// Colors
export const MAP_COLORS = {
  routeLine: '#6366f1', // Indigo
  routeLineHover: '#4f46e5',
  riderMarker: '#10b981', // Green
  parcelMarker: '#f59e0b', // Amber
  activeMarker: '#ef4444', // Red
};

// Distance and Speed
export const DEFAULT_SPEED_KMH = 30; // Average delivery speed
export const METERS_PER_KM = 1000;
export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 3600;

// Geocoding
export const GEOCODING_CONFIG = {
  language: 'en',
  region: 'IN', // India
  components: 'country:IN',
};

// Radius for nearby searches (meters)
export const SEARCH_RADIUS = {
  nearby: 5000, // 5km
  withinCity: 15000, // 15km
  regional: 50000, // 50km
};

// API Endpoints
export const GOOGLE_MAPS_ENDPOINTS = {
  directions: `${GOOGLE_MAPS_BASE_URL}/directions/json`,
  geocode: `${GOOGLE_MAPS_BASE_URL}/geocode/json`,
  placeSearch: `${GOOGLE_MAPS_BASE_URL}/place/textsearch/json`,
  placeDetails: `${GOOGLE_MAPS_BASE_URL}/place/details/json`,
  distanceMatrix: `${GOOGLE_MAPS_BASE_URL}/distancematrix/json`,
};

// Error Messages
export const MAP_ERRORS = {
  NO_API_KEY: 'Google Maps API key is not configured',
  NO_ROUTE_FOUND: 'No route found between the specified locations',
  GEOCODING_FAILED: 'Failed to geocode the address',
  INVALID_COORDINATES: 'Invalid coordinates provided',
  NETWORK_ERROR: 'Network error occurred while fetching map data',
};
